import { useEffect } from 'react';
/**
 * Хук для центрирования активной карточки в пределах видимой области.
 * Центрировать скролл на активной карточке только если она выходит за пределы центральной зоны .initiative-tracker
 */
export function useCenterActiveCard(cards, cardsRowRef) {
    useEffect(() => {
        const container = cardsRowRef.current;
        if (!container)
            return;
        const tracker = container.closest('.initiative-tracker');
        if (!tracker)
            return;
        const active = container.querySelector('.initiative-card.active');
        let startTime = null;
        function animateScroll(timestamp, container, start, change, duration) {
            if (!startTime)
                startTime = timestamp;
            const elapsed = timestamp - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const ease = progress < 0.5 ? 2 * progress * progress : -1 + (4 - 2 * progress) * progress;
            container.scrollLeft = start + change * ease;
            if (progress < 1)
                requestAnimationFrame((ts) => animateScroll(ts, container, start, change, duration));
        }
        if (active) {
            const trackerContainerRect = tracker.getBoundingClientRect();
            const activeCardRect = active.getBoundingClientRect();
            const activeCenter = activeCardRect.left + activeCardRect.width / 2;
            const centralZoneLeft = trackerContainerRect.left + trackerContainerRect.width * 0.25;
            const centralZoneRight = trackerContainerRect.left + trackerContainerRect.width * 0.75;
            if (activeCenter < centralZoneLeft || activeCenter > centralZoneRight) {
                const activeLeftInContainer = active.offsetLeft;
                const scrollTo = activeLeftInContainer + active.offsetWidth / 2 - container.clientWidth / 2;
                const duration = 900;
                const start = container.scrollLeft;
                const change = scrollTo - start;
                startTime = null;
                requestAnimationFrame((ts) => animateScroll(ts, container, start, change, duration));
            }
        }
    }, [cards, cardsRowRef]);
}
